import React, { useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box,Grid, TextField, Button, CircularProgress, Card, CardHeader, CardContent, CardActions, Divider } from '@material-ui/core'
import { Breadcrumb } from 'components'
import { connect } from 'react-redux'
import { CountriesActions, ProvincesActions } from 'redux/actions';
import { AnDropdown } from 'components/an'
import { Transition } from 'react-transition-group';
import { useHistory, useRouteMatch } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',

    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
    },
  },
  header: {
    background: '#f3f3f3b3',
    padding: '10px 16px',
  },
  content: {
    marginTop: theme.spacing(2)
  },
  selectRoot: {
    height: '28px',
    lineHeight: '28px',
    fontWeight: 500,
  },
  inputRoot: {
      '& .MuiInput-input': {
        height: '28px',
        lineHeight: '28px',
        fontWeight: 500,
      },
      
  },
}));

const ProvincesForm = props => {
    const {
        countries,
        getCountries,
        getProvince,
        saveProvince,
        setFormPropertyValue,
        province,
        reset,
        resetCountries,
    } = props
    
    const theme = useTheme();
    const classes = useStyles();
    const history = useHistory();
    const match = useRouteMatch();
    
    const transitionStyles = {
        entered:  { transform: 'translateY(0) scale(1)' },
    };

    useEffect(() => {
        if (match.params.id) {
            getProvince(match.params.id)
            getCountries(null, null)
        } else {
            getCountries(null, null)
        }

        return () => {
            resetCountries('COUNTRIES_RESET')
            reset('PROVINCES_PROVINCE_RESET')
        }
    }, [getProvince, getCountries, resetCountries, reset, match.params.id])


    useEffect(() => {
        if (province.actions.save.success) {
            history.goBack()
        }
    }, [province.actions.save.success, history])
  
    return (
        <div className={classes.root}>
            <Breadcrumb
                path={[
                    {
                        name: 'Provincias'
                    },
                    {
                        name: match.params.id ? 'Editar' : 'Nueva'
                    }
                ]}
            />

            {((match.params.id && province.loading) || province.actions.save.loading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginTop="30px"
                >
                    <CircularProgress />
                </Box>
            ) : (
                <Transition in={true} appear={true} timeout={0}>
                    {state => (
                        <Box paddingBottom={3}>
                            <Card style={{ transform: 'translateY(15px) scale(0.99)', transition: theme.transitions.create(['transform'], { duration: 150, easing: theme.transitions.easing.sharp }), ...transitionStyles[state] }}>
                                <CardHeader
                                    className={classes.header}
                                    title="Provincia"
                                    subheader={match.params.id ? "Editar provincia" : "Crear nueva provincia"}
                                />

                                <Divider />

                                <CardContent className={classes.content}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={6}>
                                            <AnDropdown
                                                label="País"
                                                value={province.data.countryId}
                                                onChange={(e) => {
                                                    setFormPropertyValue('countryId', e.target.value)
                                                }}
                                                inputProps={{
                                                    name: 'País',
                                                    id: 'country',
                                                }}
                                                displayEmpty
                                                loadingOptions={countries.loading}
                                                loadingOptionsLabel="Cargando opciones ..."
                                                emptyOptionsLabel="No hay opciones"
                                                options={countries.data.map((country) => ({
                                                    id: country.id,
                                                    name: country.nombre,
                                                    inactive: country.inactivo
                                                }))}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                classes={{
                                                    root: classes.inputRoot
                                                }}
                                                margin="normal"
                                                fullWidth
                                                label="Provincia"
                                                value={province.data.name}
                                                onChange={(e) => {
                                                    setFormPropertyValue('name', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>

                                <Divider />

                                <CardActions
                                    style={{
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            history.goBack()
                                        }}
                                    >
                                        VOLVER
                                    </Button>
                                    
                                    <Button
                                        disabled={!province.data.name || !province.data.countryId}
                                        color="primary"
                                        variant="contained"
                                        onClick={() => {
                                            if (match.params.id) {
                                                return saveProvince(province.data.id, {
                                                    nombre: province.data.name,
                                                    paisId: province.data.countryId,
                                                })
                                            }

                                            saveProvince(null, {
                                                nombre: province.data.name,
                                                paisId: province.data.countryId,
                                            })
                                        }}
                                    >
                                        GUARDAR
                                    </Button>
                                </CardActions>
                            </Card>
                        </Box>
                    )}
                </Transition>
            ))}
        </div>
    );
};

const mapStateToProps = state => ({
    countries: state.countries,
    province: state.provinces.province,
})

const mapDispatchToProps = dispatch => ({
    getCountries: (page, pageCount) => dispatch(CountriesActions.getCountries(page, pageCount)),
    getProvince: (id) => dispatch(ProvincesActions.getProvince(id)),
    saveProvince: (id, data, patch) => dispatch(ProvincesActions.saveProvince(id, data, patch)),
    setFormPropertyValue: (property, value) => dispatch(ProvincesActions.setFormPropertyValue(property, value)),
    resetCountries: (type) => dispatch(CountriesActions.reset(type)),
    reset: (type) => dispatch(ProvincesActions.reset(type))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProvincesForm);
